var ActionFactories, MainPage, StoreFactory, m, ref, store;

m = require('mithril');

StoreFactory = require('./state/StoreFactory');

ActionFactories = require('./state/ActionFactories');

MainPage = require('./ui/pages/MainPage');

store = StoreFactory();

if ((typeof navigator !== "undefined" && navigator !== null ? (ref = navigator.geolocation) != null ? ref.getCurrentPosition : void 0 : void 0) != null) {
  navigator.geolocation.getCurrentPosition(function(pos) {
    var lat, lng;
    lat = pos.coords.latitude;
    lng = pos.coords.longitude;
    return store.dispatch(ActionFactories.centreChanged({
      lat: lat,
      lng: lng
    }));
  });
}

m.mount(document.getElementById('app'), MainPage(store));

module.exports = {
  mapInit: function() {
    return store.dispatch(ActionFactories.apiLoaded(true));
  }
};

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3dvcmsvc3JjL21haW4uY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3dvcmsvc3JjL21haW4uY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsQ0FBQSxHQUFJLE9BQUEsQ0FBUSxTQUFSOztBQUNKLFlBQUEsR0FBZ0IsT0FBQSxDQUFRLHNCQUFSOztBQUNoQixlQUFBLEdBQWtCLE9BQUEsQ0FBUSx5QkFBUjs7QUFDbEIsUUFBQSxHQUFXLE9BQUEsQ0FBUSxxQkFBUjs7QUFHWCxLQUFBLEdBQVEsWUFBQSxDQUFBOztBQUVSLElBQUcsbUpBQUg7RUFDRSxTQUFTLENBQUMsV0FBVyxDQUFDLGtCQUF0QixDQUF5QyxTQUFDLEdBQUQ7QUFDeEMsUUFBQTtJQUFBLEdBQUEsR0FBTSxHQUFHLENBQUMsTUFBTSxDQUFDO0lBQ2pCLEdBQUEsR0FBTSxHQUFHLENBQUMsTUFBTSxDQUFDO1dBQ2pCLEtBQUssQ0FBQyxRQUFOLENBQWUsZUFBZSxDQUFDLGFBQWhCLENBQThCO01BQUMsS0FBQSxHQUFEO01BQUssS0FBQSxHQUFMO0tBQTlCLENBQWY7RUFId0MsQ0FBekMsRUFERjs7O0FBT0EsQ0FBQyxDQUFDLEtBQUYsQ0FBUSxRQUFRLENBQUMsY0FBVCxDQUF3QixLQUF4QixDQUFSLEVBQXdDLFFBQUEsQ0FBUyxLQUFULENBQXhDOztBQUdBLE1BQU0sQ0FBQyxPQUFQLEdBQWlCO0VBQ2hCLE9BQUEsRUFBUyxTQUFBO1dBQU0sS0FBSyxDQUFDLFFBQU4sQ0FBZSxlQUFlLENBQUMsU0FBaEIsQ0FBMEIsSUFBMUIsQ0FBZjtFQUFOLENBRE8ifQ==
